"use client";

import { Box, VStack } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { usePageSearch } from "@/features/search";
import { useUserChoices } from "@/state/globalStore";
import BacklogToolbar from "./BacklogToolbar";
import BacklogActionBars from "../views/BacklogActionBars";
import BacklogSourceSearchView from "../views/BacklogSourceSearchView";
import "instantsearch.css/themes/satellite.css"; // can be used to override default styling

export default function Backlog() {
  const { activeBacklogFocus, addSelectedOrigin, countSelectedOrigins } =
    useUserChoices();
  const { isAllowedPage } = usePageSearch();
  const [visibleOriginIds, setVisibleOriginIds] = useState<string[]>([]);
  const selectedOriginsCount = countSelectedOrigins();
  const visibleOriginsCount = visibleOriginIds.length;
  const hasSelectedOrigins = selectedOriginsCount > 0;

  const handleVisibleOriginIdsChange = useCallback(
    (_indexId: string, hitIds: string[]) => {
      setVisibleOriginIds(hitIds);
    },
    [],
  );

  const handleVisibleOriginIdsUnmount = useCallback(() => {
    setVisibleOriginIds([]);
  }, []);

  const handleSelectVisibleOrigins = useCallback(() => {
    visibleOriginIds.forEach((originId) => {
      addSelectedOrigin(originId);
    });
  }, [addSelectedOrigin, visibleOriginIds]);

  return (
    <Box>
      <VStack gap="4" align="stretch">
        <BacklogToolbar
          isSelectVisibleDisabled={!isAllowedPage || visibleOriginsCount === 0}
          onSelectVisible={handleSelectVisibleOrigins}
          selectedCount={selectedOriginsCount}
          visibleCount={visibleOriginsCount}
        />

        {activeBacklogFocus === "extract" ? (
          <Box
            display="flex"
            flexDirection={{ base: "column", md: "row" }}
            alignItems="flex-start"
            gap={{ base: "2", md: "3" }}
          >
            {hasSelectedOrigins ? <BacklogActionBars /> : null}

            <Box minW="0" flex="1" w="full">
              <BacklogSourceSearchView
                onVisibleOriginIdsChange={handleVisibleOriginIdsChange}
                onVisibleOriginIdsUnmount={handleVisibleOriginIdsUnmount}
              />
            </Box>
          </Box>
        ) : null}
      </VStack>
    </Box>
  );
}
